import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'mobNumber'
})

export class MobNumberPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): unknown {
    if (value === 0) {
      return 0
    }
    if (!value) {
      return;
    }
    return new Intl.NumberFormat('en').format(value).replace(/\,/g, `'`);
  }
}
